/*
 * フッターの INFO 開閉ブロック。
 * #info-legal などハッシュ付きで来たときに該当の details を開いてスクロールする。
 * JavaScript が無効でも details を1クリックで開けるので情報には到達できる。
 */
(function () {
  function openFromHash() {
    var hash = window.location.hash;
    if (!hash || hash.length < 2) return;

    var target;
    try {
      target = document.querySelector(hash);
    } catch (error) {
      return;
    }
    if (!target || target.tagName !== 'DETAILS') return;

    target.open = true;
    target.scrollIntoView({ block: 'start' });
  }

  window.addEventListener('hashchange', openFromHash);
  openFromHash();
})();
